// AI-GEN START - Tool: Copilot, AI: GPT-4
export const GRADE_MAPPINGS = {
  '-1': {
    shortName: 'Pre-Kindergarten',
    name: 'Pre-Kindergarten',
    member: 'Pre-Kindergartener',
  },
  0: {
    shortName: 'Kindergarten',
    name: 'Kindergarten',
    member: 'Kindergartener',
  },
  1: {
    shortName: '1st Grade',
    name: 'First Grade',
    member: '1st Grader',
  },
  2: {
    shortName: '2nd Grade',
    name: 'Second Grade',
    member: '2nd Grader',
  },
  3: {
    shortName: '3rd Grade',
    name: 'Third Grade',
    member: '3rd Grader',
  },
  4: {
    shortName: '4th Grade',
    name: 'Fourth Grade',
    member: '4th Grader',
  },
  5: {
    shortName: '5th Grade',
    name: 'Fifth Grade',
    member: '5th Grader',
  },
  6: {
    shortName: '6th Grade',
    name: 'Sixth Grade',
    member: '6th Grader',
  },
  7: {
    shortName: '7th Grade',
    name: 'Seventh Grade',
    member: '7th Grader',
  },
  8: {
    shortName: '8th Grade',
    name: 'Eighth Grade',
    member: '8th Grader',
  },
  9: {
    shortName: '9th Grade',
    name: 'Ninth Grade',
    member: '9th Grader',
  },
  10: {
    shortName: '10th Grade',
    name: 'Tenth Grade',
    member: '10th Grader',
  },
  11: {
    shortName: '11th Grade',
    name: 'Eleventh Grade',
    member: '11th Grader',
  },
  12: {
    shortName: '12th Grade',
    name: 'Twelfth Grade',
    member: '12th Grader',
  },
};
// AI-GEN END - Tool: Copilot, AI: GPT-4

// AI-GEN START - Tool: Copilot, AI: GPT-4
export function getGradeObject(
  grade: string
): { shortName: string; name: string; member: string } | undefined {
  const gradeNum = grade as keyof typeof GRADE_MAPPINGS;
  return GRADE_MAPPINGS[gradeNum];
}
// AI-GEN END - Tool: Copilot, AI: GPT-4
